// Every backend path this app calls, written the way the backend's OpenAPI
// document names it. tests/test_frontend_contract.py reads this file and fails the
// build if any of these do not exist on the server, so a rename on either side is
// caught at test time rather than as a 404 in someone's browser.
export const ENDPOINTS = {
  config: "/v1/config",
  createSession: "/v1/sessions",
  readSession: "/v1/sessions/{session_id}",
  destroySession: "/v1/sessions/{session_id}",
  addMember: "/v1/sessions/{session_id}/members",
  updateMember: "/v1/sessions/{session_id}/members/{member_id}",
  removeMember: "/v1/sessions/{session_id}/members/{member_id}",
  setPreferences: "/v1/sessions/{session_id}/preferences",
  compute: "/v1/sessions/{session_id}/compute",
  results: "/v1/sessions/{session_id}/results",
  refine: "/v1/sessions/{session_id}/refine",
  resolveInvite: "/v1/sessions/invite/{invite_token}",
  joinSession: "/v1/sessions/{session_id}/join",
  autocomplete: "/v1/geocode/autocomplete",
  venue: "/v1/venues/{venue_id}",
  feedback: "/v1/venues/{venue_id}/feedback",
  track: "/v1/analytics/track",
  adminVerify: "/v1/admin/verify",
  adminStats: "/v1/admin/stats",
  adminActive: "/v1/admin/active",
} as const;

export type EndpointName = keyof typeof ENDPOINTS;

export function path(name: EndpointName, params: Record<string, string> = {}): string {
  return ENDPOINTS[name].replace(/\{(\w+)\}/g, (_, key: string) => {
    const value = params[key];
    if (value === undefined) throw new Error(`missing path parameter '${key}' for ${name}`);
    return encodeURIComponent(value);
  });
}
